import { render, staticRenderFns } from "./ClientCompanyAprovalConfirmationModal.vue?vue&type=template&id=4c145c58&scoped=true&"
import script from "./ClientCompanyAprovalConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./ClientCompanyAprovalConfirmationModal.vue?vue&type=script&lang=js&"
import style0 from "./ClientCompanyAprovalConfirmationModal.vue?vue&type=style&index=0&id=4c145c58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c145c58",
  null
  
)

export default component.exports